import { render, staticRenderFns } from "./ViewDataContainer.vue?vue&type=template&id=0e4581bb&scoped=true"
import script from "./ViewDataContainer.vue?vue&type=script&lang=js"
export * from "./ViewDataContainer.vue?vue&type=script&lang=js"
import style0 from "./ViewDataContainer.vue?vue&type=style&index=0&id=0e4581bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4581bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
